import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-btn-nuevo-documento',
  templateUrl: './btn-nuevo-documento.component.html',
  styleUrls: ['./btn-nuevo-documento.component.css']
})
export class BtnNuevoDocumentoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
